import styled from '@emotion/styled';
import { SharedStyledChatBubble } from '../SharedChatBubble.styled';
import { theme } from '../../../theme';
export const StyledImageChatBubble = styled(SharedStyledChatBubble) `
	display: flex;
	padding: ${theme.spacing.space10};
`;
export const StyledImage = styled.img `
	border-radius: 14px;
	width: ${(props) => props.width ? `${props.width}px` : 'auto'};
	height: ${(props) => props.height ? `${props.height}px` : 'auto'};
	max-width: 276px;
	max-height: 371px;
`;
//# sourceMappingURL=ImageChatBubble.styled.js.map